import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { locationChanged } from '../ducks/router';

// Feeds the `router` slice from the history, which is what HistoryRouter then
// renders and what the ~25 router selectors read.
//
// The subscription is on the history rather than on useLocation(): history
// notifies synchronously inside the push, so one navigation stays one store
// update and the routed components render once, on a location the selectors
// already agree with.
export default history => {
  const dispatch = useDispatch();

  useLayoutEffect(
    () => history.listen(({ location, action }) => dispatch(locationChanged(location, action))),
    [dispatch, history],
  );
};
